<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        Settlement Pelunasan
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            :title="$t('settlement')"
            @click="settlement()"
          >
            <i class="fa fa-money"></i> {{$t('settlement')}}
          </button>
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>

      <div slot="footer">
        <div class="text-center">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            :title="$t('settlement')"
            @click="settlement()"
          >
            <i class="fa fa-money"></i> {{$t('settlement')}}
          </button>
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>

      <b-row>
        <b-col lg="7">
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.no_kontrak"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 79px;">Tgl.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tgl_kontrak" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.CustName" readonly></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Penggunaan</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.pinjaman_uraian" readonly></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-col lg="10">
            <b-input-group>
              <b-input-group-prepend v-if="model.model_pinjaman=='PAB'">
                <label style="width:140px;">Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label style="width:140px;">Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number
                v-if="model.model_pinjaman=='PAB'"
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <my-number
                v-else
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:140px;">Jangka Waktu</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.tenor"
                :precision="0"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">bulan</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:140px;">Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bungaod_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.model_pinjaman=='PAB'">
              <b-input-group-prepend>
                <label style="width:140px;">Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.installment_amount"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label>Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bungaod_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px;">Pelunasan Secara</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="frmdt.tipepelunasan"
              :options="optionsPelunasan"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
              disabled
            ></b-form-radio-group>
          </b-input-group>
          <b-input-group v-if="ifBertahap">
            <b-input-group-prepend>
              <label style="width:160px;">Tgl Pelunasan</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.tglmulaipelunasan" disabled></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <span class="mt-1">: {{frmdt.tglpelunasan}}</span>
            <!-- <b-form-input v-model="frmdt.tglpelunasan" class="mr-2" disabled></b-form-input> -->
          </b-input-group>
          <b-input-group v-else>
            <b-input-group-prepend>
              <label style="width:160px;">Tgl Pelunasan</label>
            </b-input-group-prepend>
            <span>{{frmdt.tglpelunasan}}</span>
          </b-input-group>
        </b-col>

      </b-row>

      <b-row class="mt-3" v-if="model.model_pinjaman=='PAB'">
        
        <b-col lg="5">
          <h5>Posisi sampai hari ini {{model.hariini | moment('DD-MMM-YYYY')}}</h5>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Total Pokok</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height:35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlprincipalcurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Total Bunga</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height:35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlinterestcurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Total Denda</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height:35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttllatechargecurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
        </b-col>
      </b-row>
      <!-- end PAB -->

      <b-row class="mt-3" v-else>  
        <b-col lg="5">
          <h5>Posisi sampai hari ini {{frmdt.hariini | moment('DD-MMM-YYYY')}}</h5>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Saldo Pokok</label>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlprincipalcurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Total Bunga & OD</label>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlinterestcurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
        </b-col>
      </b-row>
      <hr />

      <div class="mt-3" v-if="model.model_pinjaman == 'PAB'">
        <b-row>
          <b-col lg="12">
            <h5>Posisi sampai tgl pelunasan {{ frmdt.tglpelunasan | moment("DD-MMM-YYYY") }}</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="3">
            <h5>Keterangan</h5>
          </b-col>
          <b-col lg="3">
            <h5>Amount Awal</h5>
          </b-col>
          <b-col lg="3">
            <h5>Diskon</h5>
          </b-col>
          <b-col lg="3">
            <h5>Net Amount</h5>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="2">
            <label>OS Pokok Belum JT</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number
                v-model="frmdt.ospokokbelumjt"
                :precision="2"
                class="text-right"
                disabled
              ></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.diskon_ospokokbelumjt_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_ospokokbelumjt"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="2">
            <label>Tunggakan Angsuran</label>
          </b-col>
          <b-col lg="3">
             <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number
                v-model="frmdt.ttlangsuran"
                :precision="2"
                class="text-right"
                disabled
              ></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.diskon_angsuran_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
          <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_ttlangsuran"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="2">
            <label>Bunga Berjalan</label>
          </b-col>
          <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend style="height: 35px">
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.ttlinterest"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.diskon_interest_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
          <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_ttlinterest"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="2">
            <label>Denda Angsuran</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number
                v-model="frmdt.ttllatecharge"
                :precision="2"
                class="text-right"
                disabled
              ></my-number>
            </b-input-group>

          </b-col>
          <b-col lg="3">
            <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.diskon_latecharge_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
          <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_ttllatecharge"
                  :precision="2"
                  class="text-right" 
                  disabled                 
                ></my-number>
              </b-input-group>
          </b-col>
        </b-row>


        <b-row>
          <b-col lg="2">
            <label>Denda Lainnya</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number
                v-model="frmdt.dendalain"
                :precision="2"
                class="text-right"
                disabled
              ></my-number>
            </b-input-group>
            
          </b-col>
          <b-col lg="3">
            <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.diskon_dendalain_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
          <b-col lg="3">
             <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_dendalain"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="2">
            <label>8% Pinalty</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number
                v-model="frmdt.pinalty"
                :precision="2"
                class="text-right"
                disabled
              ></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.diskon_pinalty_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_pinalty"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12"><hr></b-col>
        </b-row>
        <b-row>
          <b-col lg="2">
            <h6>Total</h6>
          </b-col>
          <b-col lg="3">
            <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.ttlpayment_awal"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
          <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.ttlpayment_diskon"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.ttlpayment"
                  :state="stateTtlPay"
                  :precision="2"
                  class="text-right"
                  style="padding-right: 11px"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col offset="5" lg="3" >
              <label class="mt-2 text-right">Prepaid</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.prepaid"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col offset="5" lg="3" >
              <label class="mt-2 text-right">Jumlah yang harus masih dibayar</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.ttlmustpay"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
          </b-col>
        </b-row>
       
      </div>
      <!-- end PAB -->

      <b-row class="mt-3" v-else>

        <b-col lg="5">
          <h5>Posisi sampai tgl pelunasan {{frmdt.tglpelunasan | moment('DD-MMM-YYYY')}}</h5>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Saldo Pokok</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height:35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number v-model="frmdt.ttlprincipal" :precision="2" class="text-right" disabled></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Total Bunga & OD</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height:35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number v-model="frmdt.ttlinterest" :precision="2" class="text-right" disabled></my-number>
          </b-input-group>
        </b-col>
      </b-row>

      <hr>
      <b-row class="mt-3" no-gutters>
            <b-col md="3">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Jumlah pelunasan yang sudah dibayar</label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.cicilan_pelunasan"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
        <!-- </b-col> -->
        
      </b-row>
      <hr>
      <h6>ALOKASI SISA PEMBAYARAN</h6>
        <b-row no-gutters>
            <b-col md="3">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Pendapatan Lain-lain</label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.oth_income"
                  :precision="2"
                  class="text-right"
                ></my-number>
              </b-input-group>
            </b-col>        
        </b-row>
        <b-row no-gutters>
            <b-col md="3">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Refund</label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.refund"
                  :precision="2"
                  class="text-right"
                ></my-number>
              </b-input-group>
            </b-col>        
        </b-row>
        <b-row no-gutters>
            <b-col md="3">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Prepaid</label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.keepinprepaid"
                  :precision="2"
                  class="text-right"
                ></my-number>
              </b-input-group>
            </b-col>        
        </b-row>
      <hr>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Tanggal Surat</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.tglsurat" disabled></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Nomor Surat</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.nosurat" disabled ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Kepada</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.kepada" disabled ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Perihal</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.perihal" disabled ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Lokasi / LDSK</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.lokasiLDSK1" disabled ></b-form-input>
            <b-form-input v-model="frmdt.lokasiLDSK2" disabled ></b-form-input>
          </b-input-group>
          
          <b-input-group>
            <b-input-group-prepend>
              <label>Kronologis</label>
            </b-input-group-prepend>
            <b-form-textarea
              v-model="frmdt.kronologis"
              placeholder=""
              rows="4"
              max-rows="6"
              disabled
            ></b-form-textarea>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>CC</label>
            </b-input-group-prepend>
            <b-form-textarea
              v-model="frmdt.cc"
              placeholder=""
              rows="4"
              max-rows="6"
              disabled
            ></b-form-textarea>
          </b-input-group>

        </b-col>
      </b-row>
      <hr />
        <b-row>
            <b-col lg="4">
            <h6 class="text-center">Diajukan Oleh</h6>
            <h6 class="text-center">{{frmdt.ttd1_diajukan_nama}}</h6>
            <h6 class="text-center">{{frmdt.ttd1_diajukan_jabatan}}</h6>
            </b-col>
            <b-col lg="4">
            <h6 class="text-center">Mengetahui</h6>
            <h6 class="text-center">{{frmdt.ttd1_mengetahui_nama}}</h6>
            <h6 class="text-center">{{frmdt.ttd1_mengetahui_jabatan}}</h6>
            </b-col>
            <b-col lg="4">
            <h6 class="text-center">Disetujui Oleh</h6>
            <h6 class="text-center">{{frmdt.ttd1_disetujui_nama}}</h6>
            <h6 class="text-center">{{frmdt.ttd1_disetujui_jabatan}}</h6>
            </b-col>
        </b-row>
    <hr />
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman"></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lkuPinjaman from "./lkuPinjaman";
import pinjaman from "../../apis/pinjamankredit";
import pelunasan from "../../apis/pelunasanpinjaman";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, lkuPinjaman, Loading },
  mixins: [validationMixin],
  data() {
    return {
      showReport:false,
      reportUrl:null,
      isLoading: false,
      text: "",
      isBusy: false,
      isPelunasankey: false,
      model: {},
      frmdt: {
        statussp: null,
        pinjamankey: "",
        hariini: moment().format("YYYY-MM-DD"),
        nosurat: "",
        kepada: "",
        perihal: "",
        lokasiLDSK1: "",
        lokasiLDSK2: "",
        kronologis: "",
        cc: "",
        ttd1_diajukan_nama: "",
        ttd1_diajukan_jabatan: "",
        ttd1_mengetahui_nama: "",
        ttd1_mengetahui_jabatan: "",
        ttd1_disetujui_nama: "",
        ttd1_disetujui_jabatan: "",
        ttlinstalmentcurrent: 0,
        ttllatechargecurrent: 0,
        ttlprincipalcurrent: 0,
        ttlinterestcurrent: 0,
        ttlinstalment: 0,
        ttlprincipal: 0,
        ttllatecharge: 0,
        ttlinterest: 0,
        ttlangsuran: 0,
        ospokokbelumjt: 0,
        dendalain: 0,
        pinalty: 0,

        diskon_principal_percent: 0,
        diskon_principal_amount: 0,
        diskon_interest_percent: 0,
        diskon_interest_amount: 0,

        diskon_angsuran_percent: 0,
        diskon_angsuran_amount: 0,

        diskon_latecharge_percent: 0,
        diskon_latecharge_amount: 0,

        diskon_ospokokbelumjt_percent: 0,
        diskon_ospokokbelumjt_amount: 0,
        diskon_dendalain_percent: 0,
        diskon_dendalain_amount: 0,
        diskon_pinalty_percent: 0,
        diskon_pinalty_amount: 0,

        net_ttlprincipal: 0,
        net_ttlinterest: 0,

        net_ttlangsuran: 0,

        net_ttllatecharge: 0,

        net_ospokokbelumjt: 0,
        net_dendalain: 0,
        net_pinalty: 0,

        ttlpayment_awal: 0,
        ttlpayment_diskon: 0,
        ttlpayment: 0,
        prepaid: 0,
        ttlmustpay: 0,
        tipepelunasan: "Normal",
        oth_income:0,
        refund:0,
        keepinprepaid:0
      },
      diskon_principal_percent: 0,
      diskon_principal_amount: 0,
      diskon_interest_percent: 0,
      diskon_interest_amount: 0,

      diskon_angsuran_percent: 0,
      diskon_angsuran_amount: 0,

      diskon_latecharge_percent: 0,
      diskon_latecharge_amount: 0,

      diskon_ospokokbelumjt_percent: 0,
      diskon_ospokokbelumjt_amount: 0,
      diskon_dendalain_percent: 0,
      diskon_dendalain_amount: 0,
      diskon_pinalty_percent: 0,
      diskon_pinalty_amount: 0,

      ifCalculated: false,
      stateTtlPay: true,
      lkuPinjamanShow: false,

      optionsPelunasan: [
        { item: "Normal", name: "Normal" },
        { item: "Bertahap", name: "Bertahap" },
      ],

    };
  },
  computed: {
    canSave() {
      return this.ifCalculated;
    },
    ifBertahap() {
      console.log(this.frmdt.tipepelunasan == "Bertahap" ? true : false)
      return this.frmdt.tipepelunasan == "Bertahap" ? true : false;
    },
  },
  created: async function () {
    this.model.model_pinjaman = "PAB";
    if (this.$route.params.pelunasankey) {
      toastr.info("Loading Payment Detail, please wait");
      this.isPelunasankey = true;
      try {
        const res = await pelunasan.detail(this.$route.params.pelunasankey);
        for (const key in res) {
          this.model[key] = res[key];
          this.frmdt[key] = res[key];
        }
        this.model.tgl_kontrak = this.model.tgl_kontrak
          ? moment(this.model.tgl_kontrak).format("DD-MMM-YYYY")
          : "";
        this.frmdt.tglpelunasan = this.frmdt.tglpelunasan
          ? moment(this.frmdt.tglpelunasan).format("DD-MMM-YYYY")
          : "";

        this.frmdt.tglmulaipelunasan = this.frmdt.tglmulaipelunasan
          ? moment(this.frmdt.tglmulaipelunasan).format("DD-MMM-YYYY")
          : "";

        this.frmdt.tglsurat = this.frmdt.tglsurat
          ? moment(this.frmdt.tglsurat).format("DD-MMM-YYYY")
          : "";

        this.diskon_principal_percent = this.model.diskon_principal_percent;
        this.diskon_interest_percent = this.model.diskon_interest_percent;
        this.diskon_angsuran_percent = this.model.diskon_angsuran_percent;
        this.diskon_latecharge_percent = this.model.diskon_latecharge_percent;
        this.diskon_ospokokbelumjt_percent = this.model.diskon_ospokokbelumjt_percent;
        this.diskon_dendalain_percent = this.model.diskon_dendalain_percent;
        this.diskon_pinalty_percent = this.model.diskon_pinalty_percent;
        this.frmdt.cicilan_pelunasan= this.model.pbb_os - this.model.prepaid;

        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    }

  },
  methods: {
    async onSelectLkuPinjaman(_selected) {
      this.resetCalc();
      this.frmdt.pinjamankey = _selected.pinjamankey;
      this.frmdt.nasabahkey = _selected.nasabahkey;
      for (const key in _selected) {
        this.model[key] = _selected[key];
      }
      this.model.tgl_kontrak = _selected.tgl_kontrak
        ? moment(_selected.tgl_kontrak).format("DD-MM-YYYY")
        : "";
      this.model.pinjaman_uraian = _selected.uraian;
      this.model.ttllatecharge = 0;
      this.lkuPinjamanShow = false;
    },
    tooglePrintSave(param) {
      //console.log("$param: ", param);
      if(!param){
        this.printPelunasanpdf();
      }else{
        this.simpanCetak();
      }
    },
    close() {
      router.push({ name: "loan.pelunasanwo" });
    },
    async settlement() {
      
        if (this.frmdt.ttlpayment == 0) {
          this.stateTtlPay = false;
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
            try {
                if((this.frmdt.ttlmustpay - (this.frmdt.pbb_os - this.frmdt.prepaid)) > 0.009) {
                  toastr.error('Cicilan pelunasan belum cukup', "ERROR MESSAGE");
                }else{
                  let sisaPembayaran = (this.frmdt.pbb_os - this.frmdt.prepaid) - this.frmdt.ttlmustpay ;
                  let alokasiSisa = sisaPembayaran -(this.frmdt.oth_income+this.frmdt.refund+this.frmdt.keepinprepaid);
                  if(alokasiSisa>0.009){
                    toastr.error('Alokasi Sisa Pembayaran Tidak Sesuai', "ERROR MESSAGE");
                  }else{
                    this.isLoading= true;
                    const data = await pelunasan.settlement(this.frmdt);
                    this.isLoading= false;
                    toastr.success(`Memo Pelunasan : ${this.frmdt.nosurat} berhasil disttlement`,'Success');
                    router.push({ name: "loan.pelunasanwo" });
                  }
                  
                }
                
            } catch (error) {
                this.isLoading= false;
                toastr.error(error, "ERROR MESSAGE");
            }
          
        }
      
    },
  },
};
</script>
